import type { PropsOf } from '@emotion/react';
import styled from '@emotion/styled';
import FBTable from '@innovationdepartment/proxima-fbtable';
import { Button } from '@innovationdepartment/proxima-ui';
import type { FacebookTableViewProps } from 'types/fbTable';
import ButtonGroup from 'ui/ButtonGroup';
import FacebookTableHeader from './FacebookTableHeader';
import FacebookTableSearchFilter from './FacebookTableSearchFilter';
import fbTableCellRender from './fbTableCellRender';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 8px 16px;
  height: 100%;
  overflow-y: hidden;
`;

const FacebookTableView = (props: FacebookTableViewProps) => {
  const {
    tab,
    initialLoading,
    lastUpdate,
    loading,
    dateRange,
    onDateRangeChange,
    onTabClick,
    onRowSelect,
    campaigns,
    adsets,
    ads,
    onNext,
    onPrevious,
    metaAdAccount,
    onSelectAdAccount
  } = props;

  return (
    <Container>
      <FacebookTableHeader
        loading={initialLoading}
        metaAdAccount={metaAdAccount}
        lastUpdate={lastUpdate}
      />
      <FacebookTableSearchFilter
        onDateRangeChange={onDateRangeChange}
        dateRange={dateRange}
        metaAdAccount={metaAdAccount}
        onAdAccountChange={onSelectAdAccount}
      />
      <FBTable
        loading={loading}
        tab={tab}
        /* FBTable declares full InsightAttributes summaries, but the API only returns a subset */
        campaigns={campaigns as PropsOf<typeof FBTable>['campaigns']}
        adsets={adsets as PropsOf<typeof FBTable>['adsets']}
        ads={ads as PropsOf<typeof FBTable>['ads']}
        onTabClick={onTabClick}
        onRowSelect={onRowSelect}
        cellRender={fbTableCellRender}
      />
      <ButtonGroup style={{ marginTop: 16 }}>
        {!!onPrevious && <Button label="Previous" onClick={onPrevious} />}
        {!!onNext && <Button label="Next" onClick={onNext} />}
      </ButtonGroup>
    </Container>
  );
};

export default FacebookTableView;
